module.exports = __webpack_public_path__ + "07ef864c067bd3704162db372b64265d.svg";